var exports = {
  "ns": "Attachment.module__attachmentWrapper___RWp6RW",
  "yf": "Attachment.module__expiredOverlay___RWp6RW",
  "ri": "Attachment.module__expiredContent___RWp6RW",
};

module.exports = exports;
